import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetSurveySettingsRPC } from "./getSurveySettingsRPC";

export class GetSurveySettingsRPCClientImpl extends GetSurveySettingsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetSurveySettingsRPC.Request): Promise<LeoRPCResult<GetSurveySettingsRPC.Response, GetSurveySettingsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/GetSurveySettings",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetSurveySettingsRPC.ResponseDTO,
      GetSurveySettingsRPC.Errors.ErrorsDTO,
      GetSurveySettingsRPC.Response,
      GetSurveySettingsRPC.Errors.Errors
    >(
      response,
      "survey/GetSurveySettings",
      GetSurveySettingsRPC.Response.fromDTO,
      GetSurveySettingsRPC.Errors.fromDTO
    );
  }
}
